Object.values = Object.values
	? Object.values
	: function(obj) {
			const allowedTypes = [
				"[object String]",
				"[object Object]",
				"[object Array]",
				"[object Function]",
			];
			const objType = Object.prototype.toString.call(obj);

			if (obj === null || typeof obj === "undefined") {
				throw new TypeError("Cannot convert undefined or null to object");
			} else if (!~allowedTypes.indexOf(objType)) {
				return [];
			} else {
				// if ES6 is supported
				if (Object.keys) {
					return Object.keys(obj).map(function(key) {
						return obj[key];
					});
				}

				const result = [];
				for (const prop in obj) {
					if (obj.hasOwnProperty(prop)) {
						result.push(obj[prop]);
					}
				}

				return result;
			}
	  };

if (!Object.assign) {
	Object.defineProperty(Object, "assign", {
		enumerable: false,
		configurable: true,
		writable: true,
		value: function(target, ...args) {
			"use strict";
			if (target === undefined || target === null) {
				throw new TypeError("Cannot convert first argument to object");
			}

			const to = Object(target);
			for (let i = 0; i < args.length; i++) {
				const nextSource = args[i];
				if (nextSource === undefined || nextSource === null) {
					continue;
				}

				const keysArray = Object.keys(Object(nextSource));
				for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
					const nextKey = keysArray[nextIndex];
					const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
					if (desc !== undefined && desc.enumerable) {
						to[nextKey] = nextSource[nextKey];
					}
				}
			}
			return to;
		},
	});
}
